
import { Card } from './/ui/card.ripple';
import apiJson from "@zag-js/docs"
import { track } from 'ripple';

export component ContextTable({id}:any) {
    const data = track(() => apiJson[id]["context"])
    const entries = track(() => Object.entries(@data))

    <section class="mb-12">
        <h2 class="text-2xl font-bold mb-4">{"Context"}</h2>
        <Card class="p-6 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <div class="overflow-x-auto">
                <table class="w-full text-sm">
                    <thead>
                        <tr class="border-b border-border">
                            <th class="text-left py-2 font-semibold">{"Prop"}</th>
                            <th class="text-left py-2 font-semibold">{"Description"}</th>
                            <th class="text-left py-2 font-semibold">{"Type"}</th>
                        </tr>
                    </thead>
                    <tbody>
                        for (const item of @entries) {
                            let [name, prop] = item;
                                <tr
                                    class='not-last:border-b border-border/50'
                                >
                                    <td class="py-2 font-mono min-w-50 text-primary">{name}</td>
                                    <td class="py-2 pr-4">{prop.description}</td>
                                    <td class="py-2 font-mono text-green-600 dark:text-green-400d">
                                    {prop.type}
                                    </td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        </Card>
  </section>
}